import { RootState } from '@reducers';

export const selectHospitalNetworkPage = (state: RootState) => state.hospitalNetworkPageReducer;
